import React from "react";
import "./CategoryImageGallery.css";

/**
 * Responsive image grid for category asset galleries.
 * @param {{ items: Array<{ src: string, alt: string }>, title?: string, className?: string }} props
 */
const CategoryImageGallery = ({ items, title = "Gallery", className = "" }) => {
  if (!items || items.length === 0) return null;

  return (
    <section className={`category-image-gallery ${className}`.trim()} aria-label={title}>
      <div className="category-image-gallery__inner">
        <div className="category-image-gallery__head">
          <h2 className="category-image-gallery__title">{title}</h2>
          <div className="category-image-gallery__rule" aria-hidden="true" />
        </div>
        <ul className="category-image-gallery__grid">
          {items.map((item, index) => (
            <li key={item.src + index} className="category-image-gallery__cell">
              <div className="category-image-gallery__frame">
                <img
                  src={item.src}
                  alt={item.alt}
                  width={item.width || 800}
                  height={item.height || 600}
                  className="category-image-gallery__img"
                  loading="lazy"
                  decoding="async"
                  sizes="(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 33vw"
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default CategoryImageGallery;
